// extracted by mini-css-extract-plugin
module.exports = {"price":"ProductOption-module__price___Q979K"};